import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import SvgIcon from '../SvgIcon.js';
var IconIcSupportCenterNoBg = props => /*#__PURE__*/
// eslint-disable-next-line react/jsx-props-no-spreading
React.createElement(SvgIcon, _extends({}, props, {
  viewBox: "0 0 20 20",
  iconname: "IconIcSupportCenterNoBg"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 7H17V15H3V7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.6667 7.42857V14.2857C16.6667 14.5214 16.4667 14.7143 16.2222 14.7143H10.8889C10.8889 13.5304 9.89444 12.5714 8.66667 12.5714H6.88889C5.66111 12.5714 4.66667 13.5304 4.66667 14.7143H3.77778C3.53333 14.7143 3.33333 14.5214 3.33333 14.2857V7.42857H16.6667ZM3.77778 4C2.79722 4 2 4.76875 2 5.71429V14.2857C2 15.2312 2.79722 16 3.77778 16H16.2222C17.2028 16 18 15.2312 18 14.2857V5.71429C18 4.76875 17.2028 4 16.2222 4H3.77778Z",
  fill: "#5643CC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.50195 10.0313C9.50195 10.9977 8.71845 11.7813 7.75195 11.7813C6.78545 11.7813 6.00195 10.9977 6.00195 10.0313C6.00195 9.06475 6.78545 8.28125 7.75195 8.28125C8.71845 8.28125 9.50195 9.06475 9.50195 10.0313Z",
  fill: "#FF3296"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.71 8.72461C11.2065 8.72461 10.7983 9.1182 10.7983 9.60373V10.958C10.7983 11.4203 11.1683 11.7992 11.6383 11.8345V12.5557C11.6383 12.7136 11.8373 12.7914 11.9514 12.6783L12.7994 11.8371H14.3525C14.856 11.8371 15.2642 11.4435 15.2642 10.958V9.60373C15.2642 9.11821 14.856 8.72461 14.3525 8.72461H11.71Z",
  fill: "#0096FF"
}));
export { IconIcSupportCenterNoBg as default };
//# sourceMappingURL=IconIcSupportCenterNoBg.js.map